import { render, staticRenderFns } from "./MyRepresentatives.vue?vue&type=template&id=4d3de6be&scoped=true"
import script from "./MyRepresentatives.vue?vue&type=script&lang=js"
export * from "./MyRepresentatives.vue?vue&type=script&lang=js"
import style0 from "./MyRepresentatives.vue?vue&type=style&index=0&id=4d3de6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3de6be",
  null
  
)

export default component.exports